import React, { useState } from 'react'
import s from './GeoentityBlockImage.less'
import classnames from 'classnames'
import { checkBlockAspectFitsWhitelist, getComponentOrClassNameByGeoentityBlockAspect } from './GeoentityBlockUtils'
import { selectGeoentityImagesAlt } from '../../../store/geoentity/geoentity.selectors'
import { useSelector } from 'react-redux'

function ImageLink({ children, data }) {
  const { templatizedUrl, label } = data

  if (!templatizedUrl) return children

  return (
    <a href={templatizedUrl} title={label} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
}

function ImageComponent({ data }) {
  const { label, thumbnail, width, height } = data
  const geoentityImageAlt = useSelector(selectGeoentityImagesAlt)

  const [displayed, setDisplayed] = useState(Boolean(thumbnail))

  const onImageLoadError = () => setDisplayed(false)

  if (!displayed) return null

  const aspectClassname = getComponentOrClassNameByGeoentityBlockAspect(
    {
      normal: '',
      logo: s.logo,
      illustrationFiche: s.illustrationFiche
    },
    data
  )

  if (aspectClassname === null) return null

  const style = {
    ...(width ? { maxWidth: width } : {}),
    ...(height ? { maxHeight: height } : {})
  }

  return (
    <div className={s.container}>
      <img
        className={classnames(s.img, aspectClassname)}
        src={thumbnail}
        title={label}
        alt={geoentityImageAlt}
        style={style}
        onError={onImageLoadError}
      />
    </div>
  )
}

export default function GeoentityBlockImage(props) {
  const { data = {} } = props

  if (!checkBlockAspectFitsWhitelist(['normal', 'logo', 'illustrationFiche'], data)) return null

  return (
    <ImageLink {...props}>
      <ImageComponent {...props} />
    </ImageLink>
  )
}
